"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var StyleProvider_1 = require("../../../components/StyleProvider");
var BaseProvider_1 = require("../../BaseProvider");
var ClientStyleProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ClientStyleProvider, _super);
    function ClientStyleProvider() {
        var _this = _super.call(this, new Set()) || this;
        _this.handleCSS = _this.handleCSS.bind(_this);
        return _this;
    }
    ClientStyleProvider.prototype.component = function (children) {
        return React.createElement(StyleProvider_1.StyleProvider, { onInsertCss: this.handleCSS }, children);
    };
    ClientStyleProvider.prototype.handleCSS = function () {
        var styles = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            styles[_i] = arguments[_i];
        }
        styles.forEach(function (style) { return style._insertCss(); });
    };
    return ClientStyleProvider;
}(BaseProvider_1.BaseProvider));
exports.ClientStyleProvider = ClientStyleProvider;
//# sourceMappingURL=ClientStyleProvider.js.map